<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }" ref="articleRef">
    <van-nav-bar
      fixed
      title="所属线路"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj historyDiares" >
      <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishText"
          @load="onLoad"
          :offset="10"
          :immediate-check='false'
        >
          <van-empty description="没有数据啦~" v-show="nodataShow"/>

          <!-- <p>刷新次数: {{ count }}</p> -->
          <ul>

              <van-cell center value="" label="" is-link v-for="(item,index) in list" :key="index" @click="toxlDiares(index)">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span class="custom-title"> {{item.mlName}}</span>
                  <van-button :color="item.type == 1 ? '#F27A2B' :'#0BA57B'" plain size="mini"
                  >{{item.type == 1 ? '高跳' : (item.type==2?'低跳':'')}}线路</van-button
                >
                <div class="van-cell__label">行波模块：<span> {{item.kgDtu}} </span> 架空型：<span>{{item.jkDtu}}</span>  电缆型：{{item.dlDtu}}</div>
                <!-- <van-button color="#0BA57B" plain size="mini"
                >低跳线路</van-button
              > -->
                </template>
              </van-cell>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Col, Row, Button, NavBar, List, PullRefresh, Cell, CellGroup, Empty } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Col, Row, Button, NavBar, List, PullRefresh, Cell, CellGroup, Empty)

export default {
  name: 'getMlinesPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Empty.name]: Empty
  },
  data () {
    return {
      nodataShow: false,
      finishText: '没有更多了',
      count: 0,
      isLoading: false,
      loading: false,
      finished: false,
      pageHeight: window.innerHeight,
      currentPage3: 1, // 当前页
      pagesize: 15, // 每页显示条数
      total: '', // 总条数
      totalPage: '', // 总页数
      // type: '', // 1高跳 2低跳
      offset: 50, // 滚动条与底部距离小于 offset 时触发load事件
      list: [ ],
      scrollTop: 0, // 在data属性中记录滚动的距离
      firstTO: false // 是否第一次进入该页面标记
    }
  },
  watch: {
    // 使用watch 监听$router的变化
    $route (to, from) {
      // console.log(from.name)
      if (from.name === 'myPage') {
        this.onRefresh()
      } else if (from.name === 'xlDiaresPage') {
        // console.log(33333333333)
      }
    }

  },
  created () {
    // console.log('created')
    this.currentPage3 = parseInt(localStorage.getItem('currentPage3') || 1)

    // 创建组件时，加载第1页数据
    // this.getMlines()
    this.firstTO = false
  },
  activated () {
    // console.log('activated')
    this.$refs.articleRef.scrollTop = this.scrollTop
  },
  mounted () {
    // console.log('mounted')
    // this.getMlines()
    // console.log(this.firstTO)
    if (!this.firstTO) {
      this.onRefresh() // 触发了created就不触发mounted
    }
    // this.onRefresh()
    let article = this.$refs.articleRef // 获取到根节点
    // 绑定onscroll事件，只要滚动鼠标就会触发该事件，记录滚动的值
    article.addEventListener('scroll', this.pageScroll, true)
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
    },
    pageScroll () {
      // console.log(this.$refs.articleRef.scrollTop)
      this.scrollTop = this.$refs.articleRef.scrollTop
    },
    onRefresh () {
      this.currentPage3 = 1
      this.list = []
      this.finished = false
      // this.isLoading = true
      this.getMlines()
    },
    // 上拉时执行此函数
    onLoad () {
      if (!this.isLoading) {
        this.currentPage3 += 1
        this.getMlines()
      }
    },
    getMlines () {
      localStorage.setItem('currentPage3', this.currentPage3)// 存储当前页
      this.util.post('/getMlines', {
        currentPage: this.currentPage3, // 当前页
        pagesize: this.pagesize// 每页显示条数
      }).then(({ data }) => {
        if (data.code === 200) {
          this.total = data.data.total
          this.totalPage = data.data.totalPage

          let infolist = data.data.list
          if (infolist.length > 0) {
            this.nodataShow = false
          }

          // 数据全部加载完成
          if (infolist) {
            this.list = this.list.concat(infolist)
            this.$nextTick(() => {
              this.loading = false// 取消正在加载状态
              this.isLoading = false
              // 不限制的concat， 人家刷新了，还在保留着以前的数据啊？
              // this.list = this.currentPage === 1 ? this.list : this.list.concat(infolist)
              // console.log(this.list)
              if (this.currentPage3 < this.totalPage) { // 判断接口返回数据量小于请求数据量，则表示此为最后一页
                this.finished = false
              } else {
                this.finished = true
                if (this.list.length === 0) {
                  this.nodataShow = true
                  this.finishText = ''
                } else {
                  this.nodataShow = false
                  this.finishText = '没有更多了'
                }
              }
            })
          } else {
            this.loading = false// 取消正在加载状态
            this.isLoading = false
            this.finished = true
          }
        } else {
          this.loading = false
          this.isLoading = false
          this.currentPage3 -= 1
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    toxlDiares: function (index) {
      this.$router.push({ path: '/xlDiaresPage', query: { mlineId: this.list[index].mlineId } })// 跳转到线路详情页
    }
  },
  computed: {

  }

}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}
/deep/.custom-title{
  vertical-align: bottom;
  font-weight: bold;
  margin-right: 10px;
}
/deep/.van-cell__title{
  flex: auto;
}
.home{
  padding-top: 46px;
}
.van-cell__label span{
  margin-right: 20px;
}
</style>
